angular
  .module('contrast.factory.search', [])
  .factory('SearchFactory', function ($http, $q, UserService) {
    return {
      getSearchResults: function (queryString) {
        var httpTimeout = $q.defer()

        var request = $http({
          method: 'get',
          url: UserService.buildAPIUrl('/search'),
          timeout: httpTimeout.promise,
          params: { q: encodeURIComponent(queryString) }
        })

        var promise = request.then()
        promise._httpTimeout = httpTimeout
        return promise
      }
    }
  })
